const TipoLogo = {
  LOGO_PADRAO_COLORIDA: 'logo.png',
  LOGO_MONOCROMATICA: 'logo-monocromatica.png',
  BRASAO_COLORIDO: 'brasao-colorido.png',
  BRASAO_MONOCROMATICO: 'brasao-monocromatico.png',
  FAVICON: 'favicon.png',
};

export default TipoLogo;
